module.exports = __webpack_public_path__ + "img/forget_password_light.fa534a88.svg";